import { render } from "./IndexInformationCenter.vue?vue&type=template&id=5555f06a"
import script from "./IndexInformationCenter.vue?vue&type=script&lang=js"
export * from "./IndexInformationCenter.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__